import React, { Fragment } from "react";
import { Link, withRouter } from "react-router-dom";
import Table from "react-bootstrap/Table";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import moment from "moment";
import axios from "axios";
import { API_ROOT, API_ROOT1, API_HOST } from "../utils/api-config";
import SweetAlert from "react-bootstrap-sweetalert";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
class Fulfillments extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      checkboxes: {},
      completeAlert: false,
      allChecked: true,
    };
    this.showCompleteAlert = this.showCompleteAlert.bind(this);
    this.hideCompleteAlert = this.hideCompleteAlert.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleCheckAll = this.handleCheckAll.bind(this);
    this.handleRemind = this.handleRemind.bind(this);
  }
  componentDidMount() {
    this.props;
    this.props.fulfillments.map((del) => {
      this.setState((prevState) => {
        return {
          checkboxes: {
            ...prevState.checkboxes,
            [del.id]: false,
          },
        };
      });
    });
  }
  handleChange(event) {
    const name = event.target.name;
    const value = event.target.checked;

    this.setState((prevState) => {
      return {
        checkboxes: { ...prevState.checkboxes, [name]: value },
      };
    });
  }

  handleCheckAll() {
    this.props.fulfillments.map((del) => {
      this.setState((prevState) => {
        return {
          checkboxes: {
            ...prevState.checkboxes,
            [del.id]: true,
          },
        };
      });
    });
  }
  hideCompleteAlert() {
    this.setState({ showComplete: false });
  }
  showCompleteAlert() {
    this.setState({ showComplete: true });
  }
  handleRemind() {
    const formData = new FormData();
    let token = "Bearer " + localStorage.getItem("token");
    const config = {
      headers: {
        Authorization: token,
        "Content-Type": "application/x-www-form-urlencoded",
      },
    };
    this.props.fulfillments.map((del) => {
      if (this.state.checkboxes[del.id]) formData.append("ids[]", del.order_id);
    });

    axios
      .post(`${API_ROOT}/fulfillments/send_reminder`, formData, config)
      .then((response) => {
        if (response.data == "success") this.showCompleteAlert(response);
      });
  }

  render() {
    const { drivers } = this.props;

    return (
      <div className="container-fluid">
        <Toolbar style={{ justifyContent: "space-between" }}>
          <Typography variant="h6" id="tableTitle" component="div">
            {`${this.props.fulfillments.length} Fulfillment${
              this.props.fulfillments.length != 1 ? "s" : ""
            }`}
          </Typography>
          {this.state.showComplete && (
            <SweetAlert
              type="success"
              title="Reminders were successfully sent!"
              onConfirm={this.hideCompleteAlert}
              showCancel={false}
              confirmBtnText="OK"
              confirmBtnBsStyle="success"
              closeAnim={{
                name: "hideSweetAlert",
                duration: 100,
              }}
            />
          )}
          <div>
            <Button variant="outline-primary" onClick={this.handleRemind}>
              Send Reminders
            </Button>
            <Button
              className="ml-50"
              variant="info"
              onClick={this.handleCheckAll}
            >
              Check All
            </Button>
          </div>
        </Toolbar>
        <Table striped bordered hover responsive>
          <thead>
            <tr className="table-primary">
              <th>ID</th>
              {/* <th>Type</th> */}
              <th>Order</th>
              <th>Name</th>
              <th>SMS</th>
              <th>Email</th>
              <th>Updated</th>
              <th>Created</th>
              <th>Notes</th>
              <th>Remind?</th>
            </tr>
          </thead>
          <tbody>
            {this.props.fulfillments.map((item, i) => {
              const transit = drivers.find(
                (driv) => driv.id === this.props.fulfillments[i].transit_with
              );
              const renderElement = (status) => {
                if (status === "No phone")
                  return (
                    <span className="badge badge-pill  badge-danger">
                      No phone
                    </span>
                  );
                else if (status == "No email")
                  return (
                    <span className="badge badge-pill  badge-danger">
                      No email
                    </span>
                  );
                else if (status == "failed")
                  return (
                    <span className="badge badge-pill  badge-danger">
                      Failed
                    </span>
                  );
                else if (status == "undelivered")
                  return (
                    <span className="badge badge-pill  badge-danger">
                      Undelivered
                    </span>
                  );
                else if (status == "delivered")
                  return (
                    <span className="badge badge-pill  badge-success">
                      Delivered
                    </span>
                  );
                else if (status == "opened")
                  return (
                    <span className="badge badge-pill  badge-info">Opened</span>
                  );
                else if (status == "clicked")
                  return (
                    <span className="badge badge-pill  badge-secondary">
                      Clicked
                    </span>
                  );

                return null;
              };
              return (
                <tr
                  key={item.id}
                  className={
                    item.phone_status == "failed" ||
                    item.email_status == "failed"
                      ? "table-danger"
                      : item.entered_dc_at
                      ? "table-success"
                      : "table-primary"
                  }
                >
                  <td>
                    <Link to={`/fulfillments/${item.order_id}`}>
                      {item.order_id}
                    </Link>
                    {/* { :} */}
                    <a
                      style={{ textDecoration: "none", textColor: "white" }}
                      href={
                        item.pickup
                          ? `${API_HOST}/pickup?f=${item.tracking_number.slice(
                              8,
                              16
                            )}`
                          : `${API_HOST}/book?f=${item.tracking_number.slice(
                              8,
                              16
                            )}`
                      }
                    >
                      <span className="badge badge-pill badge-warning">
                        Schedule
                      </span>
                    </a>
                    {/* <Link to={`/rescheduleDelivery/${item.id}`}>
                     
                    </Link> */}
                  </td>
                  <td>
                    <a href={`${API_ROOT1}/deliverydetails?id=${item.id}`}>
                      {item.name}
                      <br></br>
                      {item.order_number}
                    </a>
                  </td>
                  <td>
                    {item.pickup
                      ? item.shipfrom_name
                      : item.shipto_first_name + " " + item.shipto_last_name}
                    <br></br>
                    {item.pickup ? item.shipfrom_phone : item.shipto_phone}
                  </td>
                  <td>
                    {item.pickup
                      ? item.shipfrom_phone
                        ? renderElement(item.phone_status)
                        : renderElement("No phone")
                      : item.shipto_phone
                      ? renderElement(item.phone_status)
                      : renderElement("No phone")}
                  </td>
                  <td>
                    {item.pickup
                      ? item.shipfrom_email
                        ? renderElement(item.email_status)
                        : renderElement("No email")
                      : item.shipto_email
                      ? renderElement(item.email_status)
                      : renderElement("No email")}
                  </td>
                  <td>{moment(item.updated_at).format("MMM DD")}</td>

                  <td>{moment(item.created_at).format("MMM DD")}</td>
                  <td>
                    {item.entered_dc_at ? (
                      <span className="badge badge-pill  badge-success">
                        In DC
                      </span>
                    ) : item.transit ? (
                      <span className="badge badge-pill  badge-success">
                        In car with {transit && transit.first_name}
                      </span>
                    ) : (
                      ""
                    )}
                    {item.order_notes
                      ? item.order_notes.map((note) => <li>{note}</li>)
                      : ""}
                  </td>
                  <td>
                    <Form.Check
                      type="checkbox"
                      name={item.id}
                      checked={this.state.checkboxes[item.id]}
                      onChange={this.handleChange}
                    />
                  </td>
                </tr>
              );
            })}
          </tbody>
        </Table>
        {/* </Form> */}
      </div>
    );
  }
}

export default withRouter(Fulfillments);
